import { useCallback } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import Image from 'src/components/Image';
import ModalLayoutBase, { ModalFooter } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
const ModalLayout = styled(ModalLayoutBase)`
  width: 500px;
  height: 800px;
`;
const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 0 24px;
`;
export const LogoImage = styled(Image)`
  width: 120px;
  height: 120px;
`;
const Title = styled.h2`
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: ${({
  theme
}) => theme.color.content12};
`;
const Description = styled.p`
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: ${({
  theme
}) => theme.color.content9};
`;
const ProfileInputIntroModal = () => {
  const closeModal = useSetAtom(closeModalAtom);
  const {
    t
  } = useTranslation();
  const handleStart = useCallback(() => {
    closeModal(ModalType.PROFILE_INPUT_INTRO);
  }, [closeModal]);
  return <ModalLayout isDim closeWhenClickOutside={false} navButtonType={ModalNavButtonType.NONE} mobileNavButtonType={ModalNavButtonType.NONE} data-testid='ProfileInputIntroModal' data-sentry-element="ModalLayout" data-sentry-component="ProfileInputIntroModal" data-sentry-source-file="ProfileInputIntroModal.tsx">
      <Content data-sentry-element="Content" data-sentry-source-file="ProfileInputIntroModal.tsx">
        <LogoImage src={'/images/logo/imgAzarLogin.png'} alt='Azar Logo' isBig supportImageSet data-sentry-element="LogoImage" data-sentry-source-file="ProfileInputIntroModal.tsx" />
        <Title data-sentry-element="Title" data-sentry-source-file="ProfileInputIntroModal.tsx">{t('profile_update__intro_title')}</Title>
        <Description data-sentry-element="Description" data-sentry-source-file="ProfileInputIntroModal.tsx">{t('profile_update__intro_desc')}</Description>
      </Content>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="ProfileInputIntroModal.tsx">
        <Button onClick={handleStart} id='profile_input_intro_start' data-sentry-element="Button" data-sentry-source-file="ProfileInputIntroModal.tsx">
          {t('profile_update__intro_button_cta')}
        </Button>
      </ModalFooter>
    </ModalLayout>;
};
export default ProfileInputIntroModal;